var React = require('react');

function Searchicon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.05 16.463a7.5 7.5 0 1 1 1.414-1.414l4.243 4.244a1 1 0 0 1-1.414 1.414l-4.244-4.244zM16 10.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z","fill":"#fff"}));
}

Searchicon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Searchicon;

Searchicon.default = Searchicon;
